import { render, staticRenderFns } from "./mainMenu.vue?vue&type=template&id=007b5d88&"
import script from "./mainMenu.vue?vue&type=script&lang=js&"
export * from "./mainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mainMenu.vue"
export default component.exports